import { useMutation } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import { ICreateDraftStandardSetResponse } from "@/search/Langston/types/ICreateStandardsSetDraftResponse";

export const useCreateStandardsSetDraft = () => {
  return useMutation<ICreateDraftStandardSetResponse, Error>({
    mutationFn: async (): Promise<ICreateDraftStandardSetResponse> => {
      const payload = {
        content_type: "STANDARD_SET",
        data: {
          title: "",
          content_type: "STANDARD_SET",
        },
      };

      const response = await api().post<ICreateDraftStandardSetResponse>(
        ApiCatalog.draftContent.endpoint,
        payload,
      );
      return response;
    },
  });
};
